<template>
  <b-dropdown
    v-if="show"
    variant="link"
    toggle-class="sf-nav-chip p-0"
    menu-class="sf-nav-menu"
    no-caret
    right
  >
    <template #button-content>
      <span
        class="sf-broker-dot"
        :style="{ background: current.color }"
      />
      <span class="sf-chip-text">{{ current.name }}</span>
      <feather-icon
        icon="ChevronDownIcon"
        size="14"
        class="sf-chip-caret"
      />
    </template>
    <b-dropdown-item
      v-for="(ex, key) in exchanges"
      :key="key"
      @click="selecionar(key)"
    >
      <span
        class="sf-broker-dot"
        :style="{ background: ex.color }"
      />
      <span class="sf-menu-label">{{ ex.name }}</span>
      <feather-icon
        v-if="key === selectedKey"
        icon="CheckIcon"
        size="15"
        class="sf-menu-check"
      />
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
// Seletor de corretora no navbar (redesign Soulf), só no contexto Spot.
// Compartilha estado com a Home via localStorage 'userData.selectedExchange'
// (mesma chave que a Home lê no created); ao trocar, recarrega para a Home reler.
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import { getContext } from '@/auth/utils'

export default {
  name: 'NavbarBrokerSelector',
  components: { BDropdown, BDropdownItem },

  data() {
    return {
      sel: null, // corretora selecionada (reativo)
      exchangeConfig: {
        binance: { name: 'Binance', color: '#F0B90B' },
        mexc: { name: 'MEXC', color: '#005CE6' },
      },
    }
  },

  computed: {
    userData() {
      return JSON.parse(localStorage.getItem('userData') || '{}')
    },
    corretorasAtivas() {
      return this.userData.corretorasAtivas || []
    },
    exchanges() {
      const out = {}
      this.corretorasAtivas.forEach(c => {
        const k = c.toLowerCase()
        if (this.exchangeConfig[k]) out[k] = this.exchangeConfig[k]
      })
      return out
    },
    show() {
      // exibe sempre no contexto Spot (mesmo com uma única corretora)
      return getContext() === 'spot' && Object.keys(this.exchanges).length >= 1
    },
    selectedKey() {
      if (this.sel && this.exchanges[this.sel]) return this.sel
      const persisted = this.userData.selectedExchange
      return this.exchanges[persisted] ? persisted : Object.keys(this.exchanges)[0]
    },
    current() {
      return this.exchanges[this.selectedKey] || { name: 'Binance', color: '#F0B90B' }
    },
  },

  created() {
    this.sel = this.selectedKey
  },

  methods: {
    selecionar(key) {
      if (key === this.selectedKey) return
      this.sel = key
      try {
        const ud = JSON.parse(localStorage.getItem('userData') || '{}')
        ud.selectedExchange = key
        localStorage.setItem('userData', JSON.stringify(ud))
      } catch (e) { /* ignore */ }
      // dispara a MESMA troca da Home (watcher -> atualizarDados, cache=false)
      this.$root.$emit('sf-exchange-changed', key)
    },
  },
}
</script>
